import React, { useEffect, useMemo, useRef, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useLocation, useNavigate } from "react-router";
import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaTimes } from "react-icons/fa";
// import useTabStore from "../../localStore/useTabStore";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment";
import usePermission from "../../customHook/usePermission";
import CommonDetailsModal from "../../components/CommonDetailsModal";

const WithdrawRequest = () => {
    // const { kv, set } = useTabStore();
    // const orderTab = kv.orderTab || 1;
    const arr = [
        { id: 1, name: "Pending" },
        { id: 2, name: "Approved" },
        { id: 3, name: "Rejected" },
    ];

    const location = useLocation();
    const navigate = useNavigate();
    const permission = usePermission();

    const [data, setData] = useState([]);
    const [page, setPage] = useState(location?.state?.page || 1);
    const [totalCount, setTotalCount] = useState();
    const [pagination, setPagination] = useState(null);
    const [searchText, setSearchText] = useState("");
    const pageRef = useRef(page);
    const preSearchPageRef = useRef(page);
    const [tab, setTab] = useState(location?.state?.tab || 1);

    const tabRef = useRef(location?.state?.tab || 1);

    const [showModal, setShowModal] = useState(false);

    const userData = {
        userName: "Sivanantham R",
        userId: "34287610",
        userType: "Seller/Buyer",
        phoneNumber: "7095798532",

        accountHolderName: "Sivanantham R",
        accountNumber: "34287610",
        ifscCode: "1234567890",
        upiId: "34287610",

        requestedVia: "UPI",
        requestedAmount: 500,
    };

    const handleConfirm = () => {
        console.log("Confirmed");
        setShowModal(false);
    };

    const handleDecline = () => {
        console.log("Declined");
        setShowModal(false);
    };


    const fetchData = async () => {
        let payload = {
            type: tab == 1 ? "booked" : tab == 2 ? "sold" : "cancelled",
            // page: page,
            search: searchText,
        };
        let url = `${URLS.BOOKING_LIST}?page=${page}`;
        let res = await post(url, payload);
        if (res?.status == "success") {
            setData(res?.data);
            setTotalCount(res?.count || 0);
            setPagination({
                current_page: res?.current_page || 1,
                last_page: res?.total_pages || 1,
            });
        }
    };

    useEffect(() => {
        pageRef.current = page;
    }, [page]);

    useEffect(() => {
        if (location?.state?.page) {
            // clear state after using it
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [page, searchText, tab]);

    const handleSelect = (i) => {
        setTab(i.id);
        tabRef.current = i?.id;
        // set("orderTab", i?.id);
    };

    const handleView = (i) => {
        navigate("/orders-view", {
            state: {
                id: i?.id,
                tab: tabRef.current,
                page: page,
            },
        });
    };

    const columns = useMemo(() => {
        let d = [
            {
                Header: "S.No",
                accessor: "",
                disableSortBy: true,
                width: "1%",
                Cell: ({ row }) => {
                    return <span className="sno">{row.index + 1}</span>;
                },
            },
            {
                Header: "Type",
                accessor: "type",
                width: "70%",
                Cell: ({ value }) => {
                    return <p className="mb-0">{value || "N/A"}</p>;
                },
            },
            {
                Header: "ID",
                accessor: "id",
                width: "70%",
                Cell: ({ value }) => {
                    return <p className="mb-0">{value || "N/A"}</p>;
                },
            },
            {
                Header: "User Name",
                accessor: "user_name",
                width: "70%",
                Cell: ({ value }) => {
                    return <p className="mb-0">{value || "N/A"}</p>;
                },
            },
            {
                Header: "Req.Amount",
                accessor: "amount",
                width: "70%",
                Cell: ({ value }) => {
                    return <p className="mb-0">{value}</p>;
                },
            },
            {
                Header: "Date & Time",
                width: "70%",
                Cell: ({ row }) => {
                    const isPreBooking = row?.original?.booking_type === "Pre Booking";

                    const dateTime = isPreBooking
                        ? row?.original?.created_at
                        : row?.original?.created_at;

                    return (
                        <p className="mb-0 text-nowrap">
                            {dateTime
                                ? moment(dateTime).format("DD-MM-YYYY, h:mm A")
                                : "--"}
                        </p>
                    );
                },
            }
        ];

        let action = {
            Header: "Action",
            accessor: "action",
            disableSortBy: true,
            width: "20%",
            Cell: ({ row }) => {
                return (
                    <>
                        {permission?.includes("CAN-VIEW-ORDERS_MANAGEMENT") && (
                            <button
                                className="action-btn d-flex ac-jc"

                                onClick={() => setShowModal(true)}
                            >
                                <FaEye />
                            </button>
                        )}
                    </>
                );
            },
        };

        return [...d, action];
    }, [page]);

    const handleClearSearch = () => {
        setSearchText("");
        setPage(preSearchPageRef.current || 1);
    };

    return (
        <div>
            <PageHeader title="Withdraw Request" />
            <div className="d-flex gap-5 mb-5">
                {arr.map((i) => {
                    return (
                        <button
                            onClick={() => handleSelect(i)}
                            className={
                                tab == i.id ? "header-action-btn" : "header-action-white-btn"
                            }
                            key={i.id}
                        >
                            {i.name}
                        </button>
                    );
                })}
            </div>

            <div className="header-row">
                <h2 className="total-count">Total: {totalCount || 0}</h2>

                <div className="search-wrapper">
                    <input
                        type="text"
                        placeholder="Search"
                        className="search-input"
                        value={searchText || ""}
                        onChange={(e) => {
                            const val = e.target.value;

                            if (!searchText && val) {
                                preSearchPageRef.current = page || 1;
                                setPage(1);
                            } else if (searchText && !val) {
                                setPage(preSearchPageRef.current || 1);
                            }

                            setSearchText(val);
                        }}
                    />
                    {searchText && (
                        <FaTimes
                            className="search-clear-icon"
                            onClick={handleClearSearch}
                        />
                    )}
                </div>
            </div>

            <CommonTable
                columns={columns}
                data={data || []}
                pagecount={pagination}
                setPageno={setPage}
                pageno={page || 1}
            />
            <CommonDetailsModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onDecline={handleDecline}
                onConfirm={handleConfirm}
                data={userData}
            />
        </div>
    );
};

export default WithdrawRequest;
